import { map, mergeDeepRight } from 'ramda'
import VideoClip from '@/router/modules/h5/video-clip'
import Login from '@/router/modules/h5/login'
import Dy from '@/router/modules/h5/dy'
import AddShowCase from '@/router/modules/h5/add-showcase'
import Activity from '@/router/modules/h5/activity'
import Message from '@/router/modules/h5/message'
// import Chanxuan from '@/router/modules/h5/chanxuan'

const pages = [
  {
    path: '/h5/',
    component: () => import(/* webpackChunkName: "'h5-pages'" */ '@/views/h5/index.vue'),
    children: [
      {
        path: 'mini-transit',
        name: 'h5-mini-transit',
        component: () => import(/* webpackChunkName: "h5/h5-mini-transit" */ '@/views/h5/h5-transit')
      },
      ...Login,
      ...VideoClip,
      ...AddShowCase,
      ...Dy,
      ...Activity,
      ...Message
    ]
  }
]

export default pages |> map(mergeDeepRight({ meta: { requireLogin: true, notShowDialog: true } }))
